import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
//import { File } from 'ionic-native';
import * as ImgCache from 'imgcache.js';
declare var cordova: any;

@Injectable()
export class IonImgCacheService {
  constructor(private platform: Platform) {
    if(!ImgCache.ready) {
      this.init({debug: false, quota: 50, folder: 'ionic-img-cache'});
    }
  }

  init({
    debug = false,
    quota = 50,
    folder = 'ionic-img-cache'
  }): void {
    this.configure(debug, quota, folder);
    this.imgCacheInit(debug);
  }

  private configure(debug: boolean, quota: number, folder: string): void {
    ImgCache.options.skipURIencoding = true;
    ImgCache.options.debug = debug;
    ImgCache.options.localCacheFolder = folder;
    ImgCache.options.chromeQuota = quota * 1024 * 1024;
    if(typeof(cordova) != 'undefined'){
      ImgCache.options.cordovaFilesystemRoot = cordova.file.dataDirectory;
      console.log('path--------------------------');
      console.log(cordova.file.dataDirectory);
    }
  }

  private imgCacheInit(debug: boolean): void {
    let message: string;

    this.platform
      .ready()
      .then(() => {
        ImgCache.init(() => {
          if (debug) {
            message = 'ionicImgCache initialized';

            if (console.info) {
              console.info(message);
            }
            else {
              console.log(message);
            }
          }
        }, () => {
          if (debug) {
            message = 'Failed to init ionicImgCache';

            if (console.error) {
              console.error(message);
            }
            else {
              console.log(message);
            }
          }
        });
      });
  }

  private checkImgCacheReady(): Promise<boolean> {
    return new Promise(resolve => {
      if (ImgCache.ready) {
        resolve(true);
      }
      else {
        document.addEventListener('ImgCacheReady', () => {
          resolve(true);
        }, false);
      }
    });
  }

  checkCacheStatus(src: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.checkImgCacheReady()
        .then(() => {
          ImgCache.isCached(src, (path, success) => {
            if (success) {
              resolve(path);
            }
            else {
              ImgCache.cacheFile(src, () => {
                ImgCache.isCached(src, (path, success) => {
                  resolve(path);
                }, reject);
              }, reject);
            }
          }, reject);
        })
        .catch(reject);
    });
  }

  cache(el): void {
    setTimeout(function(){
      // console.log('cache SRR:', el.src);
      this.checkCacheStatus(el.src)
      .then(() => {
        // console.log('use Cache File -------------------');
        ImgCache.useCachedFile(el);
      });
    }.bind(this),10); 
  }
  clearCache(): void{
    return ImgCache.clearCache()
  }
}



// WEBPACK FOOTER //
// ./src/modules/ionic2-img-cache/ion-img-cache.service.ts